import React from 'react';
import GridConfigCondition from 'core/grid/domain/gridConfigCondition';
import GridConfig from 'core/grid/domain/gridConfig';
import ConditionValueForm, {CONDITIONVALUEFORMCONTEXT} from 'core/grid/component/conditionValueForm';
import {TExtractFieldFn} from 'core/form/formUtils';
import {action} from "mobx";
import Grid from "core/grid/domain/grid";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";

interface SuperFilterBarProps {
  // gridConfig: GridConfigColumn;
  // field: MdField;
  // sortObject: SortItem;
  // onClickLink: Function;
  refreshGrid: Function;
  gridConfig: GridConfig;
  grid: Grid;
}



@observer
export default class SuperFilterBar extends React.Component<SuperFilterBarProps, undefined>  {

  componentDidMount(): void {
    let {grid, gridConfig} = this.props;
    let entitiesToFetch = gridConfig.getSuperFilters().filter(gcc => gcc.field.hasLocalValueSource())
      .map(gcc => ({entity: gcc.field.valueSource, lov: true}));

     mdEntityService.fetchEntities(entitiesToFetch)
      .then(action("action-cb", entityMap => {
        grid.initSuperFilter();
      }));
  }


  @action submitCondition = (evt?) => {
    console.log("submitCondition");
    if (evt) evt.preventDefault();
    let {grid} = this.props;

    let allOk = true;
    grid.getSuperFilters().forEach(gcc => {
      let form =  gcc.getForm("ConditionValueForm");
      if (!form.validateForm(gcc)) {
        allOk = false;
      }
    });
    if (allOk) {
      this.props.refreshGrid();
    }
  };

  render(): JSX.Element | false | null {
    let {grid, gridConfig} = this.props;
    console.debug("render SuperFilterBar conditionArray = ", grid.getSuperFilters());

    return (
      <form onSubmit={this.submitCondition} className="md-grid-super-filter">
        {grid.getSuperFilters().map( (gcc,i) => (<SuperFilter key={i} grid={grid} gridConfig={gridConfig} conditionObject={gcc} onSuccess={this.submitCondition} />))}
      </form>
    );
  }
}

interface SuperFilterProps {
  conditionObject: GridConfigCondition;
  gridConfig: GridConfig;
  grid: Grid;
  onSuccess: () => void;
}


@observer
class SuperFilter extends React.Component<SuperFilterProps, undefined>  {


  extractFieldFnHandler: TExtractFieldFn<GridConfigCondition> = (dataObject,fieldDef) => dataObject.field;

  render() {
    let {conditionObject, gridConfig, onSuccess} = this.props;
    console.debug("render superfilter, entity %O, entities %O, condition $O", conditionObject.getEntityRef(), mdEntityService.entityMap, conditionObject);
    return (
      <div>
        <ConditionValueForm dataObject={conditionObject} rootObject={gridConfig} entities={mdEntityService.entityMap} context={CONDITIONVALUEFORMCONTEXT.SUPERFILTER} onSuccess={onSuccess}
                            entity={conditionObject.getEntityRef()} extractFieldFn={this.extractFieldFnHandler} />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/grid/component/superFilter.tsx